var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    attrs: {
      "title": "Faturamento",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 5;
      }
    }
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Valor R$",
      "label-for": "valorPagamento"
    }
  }, [_c('money', _vm._b({
    key: _vm.keyToReRender,
    staticClass: "form-control",
    class: {
      hasErrorsValor: _vm.valorError,
      inputFilledvalor: _vm.valorFilled
    },
    attrs: {
      "id": "valorPagamento",
      "name": "valorPagamento",
      "value": _vm.valorPagoARealizar,
      "disabled": _vm.hasNoProductsOrServices
    },
    on: {
      "input": _vm.onInputValue
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Desconto",
      "label-for": "valorDesconto"
    }
  }, [_c('b-input-group', [_vm.form.desconto_tipo === 'valor' ? _c('money', _vm._b({
    key: 'desconto-valor-' + _vm.keyToReRender,
    staticClass: "form-control",
    attrs: {
      "id": "valorDesconto",
      "name": "valorDesconto",
      "disabled": _vm.hasNoProductsOrServices
    },
    model: {
      value: _vm.form.desconto,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "desconto", $$v);
      },
      expression: "form.desconto"
    }
  }, 'money', _vm.configMask, false)) : _c('b-form-input', {
    key: 'desconto-percentual-' + _vm.keyToReRender,
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "disabled": _vm.hasNoProductsOrServices,
      "placeholder": "0,00"
    },
    model: {
      value: _vm.form.desconto,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "desconto", _vm._n($$v));
      },
      expression: "form.desconto"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "light"
    },
    on: {
      "click": _vm.toggleTipoDesconto
    }
  }, [_vm._v(" " + _vm._s(_vm.form.desconto_tipo === "valor" ? "R$" : "%") + " ")])], 1)], 1), _vm.form.desconto_tipo === 'percentual' ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Será aplicado sobre o total (produtos + serviços). ")]) : _vm._e()], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Forma de Pagamento",
      "label-for": "forma_pagamento"
    }
  }, [_c('VueSelect', {
    key: _vm.keyToReRender,
    ref: "buscar_forma_pagamento",
    class: {
      hasErrors: _vm.pagamentoError,
      inputFilled: _vm.pagamentoFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.formas_pagamento,
      "disabled": _vm.valorPagoARealizar === 0 || _vm.hasNoProductsOrServices
    },
    on: {
      "search": _vm.onSearchFormaPagamentos,
      "input": _vm.setFormaPagamento
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(_vm._s(option.descricao))])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(_vm._s(option.descricao))])];
      }
    }]),
    model: {
      value: _vm.formaPagamento,
      callback: function callback($$v) {
        _vm.formaPagamento = $$v;
      },
      expression: "formaPagamento"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Seleciona a forma de pagamento")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('TableApp', {
    key: _vm.keyToReRender,
    ref: "valor",
    attrs: {
      "item": "pagamento",
      "data": _vm.pagamento,
      "fields": _vm.fields,
      "classFilterColumn": "valor"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'id' ? _c('span', [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.originalIndex + 1) + " ")])])]) : _vm._e(), props.field == 'valor' ? _c('span', [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-pagamento",
            modifiers: {
              "modal-pagamento": true
            }
          }],
          staticClass: "font-weight-bold text-muted cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.changePagamento(props.rowData.originalIndex);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.valor, 2)) + " ")])])]) : _vm._e(), props.field == 'vencimento' ? _c('span', [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-calendar",
            modifiers: {
              "modal-calendar": true
            }
          }],
          staticClass: "font-weight-bold text-muted cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.selectVencimento(props.rowData.originalIndex);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.vencimento, "DD/MM/YYYY")) + " ")])])]) : _vm._e()];
      }
    }])
  })], 1)], 1), _c('b-row', [_c('button', {
    ref: "submit_novo_pagamento123",
    staticClass: "btn btn-secondary font-weight-bold",
    attrs: {
      "disabled": _vm.isAllInputsNotFull
    },
    on: {
      "click": _vm.addPagamento
    }
  }, [_vm._v(" + Adicionar Pagamento ")])])], 1)], 1), _c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-row', {
    staticClass: "d-flex flex-row-reverse px-10"
  }, [_c('div', {
    staticClass: "d-flex flex-column text-md-right"
  }, [_c('span', {
    staticClass: "font-size-lg font-weight-bolder mb-1"
  }, [_vm._v("A PAGAR")]), _c('span', {
    key: _vm.keyToReRender + 1,
    staticClass: "font-size-h2 font-weight-boldest mb-1"
  }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.subtotal, 2)) + " ")]), _c('span', {
    key: _vm.keyToReRender,
    staticClass: "text-success"
  }, [_vm._v(" Valor Pago: R$ " + _vm._s(_vm.numberToReal(_vm.valorPago, 2)) + " ")])])])], 1)], 1), _c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('TableApp', {
    key: _vm.keyToReRender,
    ref: "formaPagamento",
    staticClass: "mt-10",
    attrs: {
      "item": "pagamento",
      "titulo": "Pagamentos",
      "data": _vm.form.pagamentos,
      "fields": _vm.fieldsPagamentosRealizados,
      "classFilterColumn": "formaPagamento"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'forma_pagamento' ? _c('span', [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.forma_pagamento.descricao) + " ")])])]) : _vm._e(), props.field == 'valor' ? _c('span', [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.valor)) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.removePagamento(props.rowData, props.rowData.originalIndex);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])]) : _vm._e()];
      }
    }])
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-calendar",
      "title": "Ajustar vencimento",
      "size": "sm",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancelar")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarVencimento
          }
        }, [_vm._v("Salvar")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-calendar', {
    attrs: {
      "locale": "pt-BR"
    },
    model: {
      value: _vm.vencimentoSelected,
      callback: function callback($$v) {
        _vm.vencimentoSelected = $$v;
      },
      expression: "vencimentoSelected"
    }
  })], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-pagamento",
      "title": "Ajustar pagamento",
      "size": "sm",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancelar")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarPagamento
          }
        }, [_vm._v("Salvar")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.salvarPagamento.apply(null, arguments);
      }
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valorPagamento",
      "name": "valorPagamento",
      "value": _vm.valorPagamento
    },
    on: {
      "input": _vm.changePagamentoEdited
    }
  }, 'money', _vm.configMask, false))], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };